export const getSearchInputElements = (el) => [
    el.querySelector(".search-input"),
    el.querySelector(".search-input__input"),
    el.querySelector(".search-input__reset"),
];

export const handleSearchInput = (el, className, e) =>
    el.classList[e.target.value.length > 0 ? "add" : "remove"](className);

export const handleSearchReset = (inputEl) => {
    inputEl.value = "";
    inputEl.dispatchEvent(new Event("input"));
    inputEl.focus();
};
